const USDFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

export const formatCurrencyShort = (val: number): string => {
  if (val >= 10000000000) {
    return USDFormat.format(Math.round(val / 1000000000)) + `B`;
  }
  if (val >= 1000000000) {
    return USDFormat.format(Math.round(val / 100000000) / 10) + `B`;
  }
  if (val >= 10000000) {
    return USDFormat.format(Math.round(val / 1000000)) + `M`;
  }
  if (val >= 1000000) {
    return USDFormat.format(Math.round(val / 100000) / 10) + `M`;
  }
  if (val >= 10000) {
    return USDFormat.format(Math.round(val / 1000)) + `K`;
  }
  if (val >= 1000) {
    return USDFormat.format(Math.round(val / 100) / 10) + `K`;
  }

  return USDFormat.format(val);
};
